import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Medication } from 'src/app/models/medication';
import { MedicationService } from '../../../../../../services/medication.service';
import { DataRecord, DataRecordInt } from 'src/app/models/datarecord';
import { MedicationFamily } from 'src/app/models/medicationfamily';
import { MedFamLookupComponent } from 'src/app/options/inventory/medications-inv/medfamlookup/medfamlookup.component';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { forkJoin } from 'rxjs';
import { Settings } from 'src/app/services/settings';
import { MedicationImage } from 'src/app/models/medicationimage';
import { QuickaddmanuforComponent } from 'src/app/components/quickaddmanufor/quickaddmanufor.component';
import { QuickaddmanubyComponent } from 'src/app/components/quickaddmanuby/quickaddmanuby.component';
import { ManufacturedBy, ManufacturedFor } from 'src/app/models/manufacturer';

@Component({
	selector: 'app-quickaddmedication',
	templateUrl: './quickaddmedication.component.html',
	styleUrls: ['./quickaddmedication.component.css']
})
export class QuickaddmedicationComponent implements OnInit {

	public medicationFamilyList: MedicationFamily[];
	public selectedRecord: Medication;
	public selectedMedicationFamily: MedicationFamily;

	imageTabIndex = 0;

	public valSchedule: any;
	public valRawNDCNumber: any;
	public valOMNDCNumber: any;
	public valItemPrefix: any;
	public valDesc: any;
	public valPkgSize: any;
	public valGenricOrBrand: any;
	public valUnit: any;
	public valLotNumber: any;
	public valCostBase: any;
	public valPrice: number;
	public valAWP: any;
	public valStatus: any;
	public valId: any;
	public valCompareTo: any;
	public valNdcFormat: any;
	public valMedicationFamily: any;
	public manufactureByList: ManufacturedBy[];
	public manufactureForList: ManufacturedFor[];

	public selectedManuFor: ManufacturedFor;
	public selectedManuBy: ManufacturedBy;
	public selectedNdcFormat: DataRecordInt;
	public ndcFormatList: any;
	public valStorageInstructions: any;
	public selectedMedication: Medication;

	containerInputMethod: string = 'paste';
	doseInputMethod: string = 'paste';
	localImages: { file?: File; base64?: string; imageType: 'Container' | 'Dose' }[] = [];

	strErr = '';
	mode = 'add';


	public displayMedFamilyDlg = false;
	public displayManuForDlg = false;
	public displayManuByDlg = false;
	@ViewChild('medFamilyLookup', { static: true }) medFamilyLookup: MedFamLookupComponent;
	@ViewChild('quickAddManuFor', { static: true }) quickAddManuFor: QuickaddmanuforComponent;
	@ViewChild('quickAddManuBy', { static: true }) quickAddManuBy: QuickaddmanubyComponent;

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter();

	constructor(public medicationService: MedicationService, public txService: TransactionHistoryService) { }

	ngOnInit(): void {
		/** ndc format listing **/
		this.ndcFormatList = [];
		this.ndcFormatList.push(new DataRecordInt(541, 'Five-four-one'));
		this.ndcFormatList.push(new DataRecordInt(532, 'Five-three-two'));
		this.ndcFormatList.push(new DataRecordInt(442, 'Four-four-two'));


	}
	onShowHandlerAdd(ndcNumber: any) {
		this.mode = 'add';
		this.queryRecords();
		this.clear();
		this.formatNdc(532);
		this.valRawNDCNumber = ndcNumber;
		this.onNDCFocusOut();
	}
	onShowHandlerEdit(medication: Medication) {
		this.mode = 'edit';
		this.selectedMedication = medication;

		// Thumb rule: if incoming NDC has dashes, it's orig NDC, otherwise it's raw NDC
		// First check rawNdcNumber, then origNdcNumber as fallback
		let input = medication.rawNdcNumber || medication.origNdcNumber || '';

		if (input.includes('-')) {
			// Has dashes - it's ORIGINAL NDC
			this.valOMNDCNumber = input;
			this.valRawNDCNumber = input.replace(/-/g, '');
		} else {
			// No dashes - it's RAW NDC
			this.valRawNDCNumber = input;
			// Try to get orig NDC from the other field if it has dashes
			const otherField = medication.origNdcNumber || '';
			if (otherField.includes('-')) {
				this.valOMNDCNumber = otherField;
			} else {
				this.valOMNDCNumber = '';
			}
		}
		this.formatNdc(532);  
		this.queryRecords();
	}

	displayDetails() {
		if (!this.selectedMedication) {
			return;
		}
		this.selectedMedicationFamily = this.selectedMedication['medicationFamily'];
		this.valMedicationFamily = this.selectedMedicationFamily.description;
		this.valDesc = this.selectedMedicationFamily.description;
		this.valStorageInstructions = this.selectedMedication.storageInstructions;
		this.valAWP = this.selectedMedication.awp;
		this.valPrice = this.selectedMedication.lastCost;
		this.valPkgSize = this.selectedMedication.packageSize;
		this.selectedManuBy = this.manufactureByList.find(item => item.id === this.selectedMedication.manufacturedById);
		this.selectedManuFor = this.manufactureForList.find(item => item.id === this.selectedMedication.manufacturedForId);
	}

	queryRecords() {
		forkJoin({
			manufactureBy: this.medicationService.getAllManufactureBy(),
			manufactureFor: this.medicationService.getAllManufactureFor(),
			medicationFamily: this.medicationService.getAllMedicationFamily()
		}).subscribe(({ manufactureBy, manufactureFor, medicationFamily }) => {
			this.manufactureByList = manufactureBy;
			this.manufactureForList = manufactureFor;
			this.medicationFamilyList = medicationFamily;

			this.manufactureForList = manufactureFor
				.map(x => ({ ...x, description: `${x.labeler} - ${x.description}` }))
				.sort((a, b) => Number(a.labeler) - Number(b.labeler));

			this.populateManuForMatchingData();
			if (this.mode === 'edit') {
				this.displayDetails();
			}

		});
	}

	populateManuForMatchingData() {
		try {
			this.selectedManuFor = this.manufactureForList.find(r => r.labeler === this.valOMNDCNumber.substring(0, 5));
		} catch (err) { }

	}
	public getMedicationFamily(paramId: number) {
		for (const rec of this.medicationFamilyList) {
			if (rec.id === paramId) {
				this.selectedMedicationFamily = rec;
				return this.selectedMedicationFamily;
			}
		}
		return undefined;
	}
	public showMedFamilySelection(): void {
		let filterVal = '';
		this.displayMedFamilyDlg = true;
		if (this.valDesc?.length > 20) {
			filterVal = this.valDesc.substr(0, 20);
		}
		this.medFamilyLookup.setTableData(filterVal);
	}
	public setMedicationFamilyRecord(rec: any): void {
		this.selectedMedicationFamily = rec;
		this.valMedicationFamily = rec.description;
		this.valDesc = rec.description;
		this.displayMedFamilyDlg = false;
	}



	cancel() {
		this.clear();
	}

	clear() {
		this.valRawNDCNumber = '';
		this.valDesc = '';
		this.valPkgSize = '';
		this.valAWP = null;
		this.valStatus = 'Active';
		this.selectedManuBy = null;
		this.selectedManuFor = null;
		this.selectedNdcFormat = null;
		this.selectedMedicationFamily = null;
		this.valMedicationFamily = '';
		this.valStorageInstructions = '';
		this.valPrice = 0.0;
		this.localImages = [];
	}
	public setNDCFormat(ndcFmt: number): void {
		this.selectedNdcFormat = this.ndcFormatList.find(s => s.id === ndcFmt);
	}
	public onNDCFocusOut(): void {
		if (!this.valRawNDCNumber || this.valRawNDCNumber.length === 0) {
			return;
		}

		// Check if NDC has dashes
		if (this.valRawNDCNumber.includes('-')) {
			// Has dashes - treat as orig NDC
			this.valOMNDCNumber = this.valRawNDCNumber;
			this.valRawNDCNumber = this.valRawNDCNumber.replaceAll('-', '');
		} else {
			// No dashes - treat as raw NDC, derive orig NDC
			
			if (this.valRawNDCNumber.length < 12) {
				return;
			}
			if (!this.selectedNdcFormat) {
				return;
			}

			// Extract 10-digit NDC based on raw NDC length (orig NDC is always 10 digits)
			let rawNdc = '';
			if (this.valRawNDCNumber.length === 12) {
				// 12-digit: Remove first and last digit to get 10 digits
				rawNdc = this.valRawNDCNumber.substring(1, 11);
			} else if (this.valRawNDCNumber.length === 14) {
				// 14-digit GTIN: Skip first 2 digits, take next 10 digits
				rawNdc = this.valRawNDCNumber.substring(2, 12);
			} else if (this.valRawNDCNumber.length === 13) {
				// 13-digit: Skip first 2 digits, take next 10 digits
				rawNdc = this.valRawNDCNumber.substring(2, 12);
			} else {
				// For other lengths, take middle 10 digits
				const startPos = Math.max(0, Math.floor((this.valRawNDCNumber.length - 10) / 2));
				rawNdc = this.valRawNDCNumber.substring(startPos, startPos + 10);
			}
			
			// Format based on NDC format: insert dashes at correct positions
			let formattedNdc = '';
			switch (Number(this.selectedNdcFormat.id)) {
				case 532: // 5-3-2 format
					formattedNdc = rawNdc.substring(0, 5) + '-' + 
					               rawNdc.substring(5, 8) + '-' + 
					               rawNdc.substring(8, 10);
					break;
				case 541: // 5-4-1 format
					formattedNdc = rawNdc.substring(0, 5) + '-' + 
					               rawNdc.substring(5, 9) + '-' + 
					               rawNdc.substring(9, 10);
					break;
				case 442: // 4-4-2 format
					formattedNdc = rawNdc.substring(0, 4) + '-' + 
					               rawNdc.substring(4, 8) + '-' + 
					               rawNdc.substring(8, 10);
					break;
			}

			this.valOMNDCNumber = formattedNdc;
		}
	}

	public formatNdc(event: any): void {

		this.setNDCFormat(event);

		if (!this.valOMNDCNumber || this.valOMNDCNumber.length === 0 || this.valOMNDCNumber.length === undefined || this.valOMNDCNumber === null) {
			return;
		}
		const saveNDC = this.valOMNDCNumber;
		const rawNdc = this.valOMNDCNumber.replaceAll('-', '');
		let counter = 0;
		let tmpReverse = '';

		for (let i = rawNdc.length - 1; i > - 1; i--) {
			tmpReverse += rawNdc[i];
			counter++;

			switch (Number(this.selectedNdcFormat.id)) {
				case 532:
					if (counter === 2 || counter === 5) {
						tmpReverse += '-';
					}
					break;
				case 541:
					if (counter === 1 || counter === 5) {
						tmpReverse += '-';
					}
					break;
				case 442:
					if (counter === 2 || counter === 6) {
						tmpReverse += '-';
					}
					break;
				default:
					tmpReverse = saveNDC;
					break;
			}
		}
		/** reverse the string so that it is the right way round **/
		this.valNdcFormat = this.selectedNdcFormat.id;
		this.valOMNDCNumber = tmpReverse.split('').reverse().join('');
	}

	public validateFields() {

		if (this.selectedMedicationFamily === undefined || this.selectedMedicationFamily === null || this.selectedMedicationFamily.id === 0) {
			this.strErr = 'Please set the Medication Family';
			DwUtils.setFocus('medicationFamily');
			return false;
		}
		if (!this.valOMNDCNumber || this.valOMNDCNumber.length === 0) {
			this.strErr = 'Please enter NDC Number';
			DwUtils.setFocus('ndcNumber');
			return false;
		}
		if (this.valDesc === undefined || this.valDesc.length === 0) {
			this.strErr = 'Please enter Description';
			DwUtils.setFocus('desc');
			return false;
		}
		if (this.valPkgSize === undefined || this.valPkgSize.length === 0) {
			this.strErr = 'Please enter Package size';
			DwUtils.setFocus('packagesize');
			return false;
		}
		if (this.mode === 'add') {
			const hasContainerImage = this.localImages.some(img => img.imageType === 'Container');
			const hasDoseImage = this.localImages.some(img => img.imageType === 'Dose');

			if (!hasContainerImage) {
				this.strErr = 'Please provide a Container image.';
				return false;
			}

			if (!hasDoseImage) {
				this.strErr = 'Please provide a Dose image.';
				return false;
			}
		}

		return true;
	}
	public submitRecord() {
		this.strErr = '';
		if (!this.validateFields()) return;
		if (this.mode === 'add') {
			this.addNewMedication();
		} else {
			this.updateExistingMedication();
		}
	}
	public updateExistingMedication(): void {
		if (!this.selectedMedication) return;

		this.selectedMedication.description = this.valDesc;
		this.selectedMedication.rawNdcNumber = this.valRawNDCNumber;
		this.selectedMedication.origNdcNumber = this.valOMNDCNumber;
		this.selectedMedication.ndcFormat = this.valNdcFormat;
		this.selectedMedication.packageSize = this.valPkgSize;
		this.selectedMedication.activeStatus = "Active";
		this.selectedMedication.awp = this.valAWP;
		this.selectedMedication.lastCost = this.valPrice;
		this.selectedMedication.storageInstructions = this.valStorageInstructions;

		if (this.selectedMedicationFamily) {
			this.selectedMedication.medicationFamilyId = this.selectedMedicationFamily.id;
		}
		if (this.selectedManuBy) {
			this.selectedMedication.manufacturedById = this.selectedManuBy.id;
		}
		if (this.selectedManuFor) {
			this.selectedMedication.manufacturedForId = this.selectedManuFor.id;
		}

		this.medicationService.updateMedication(this.selectedMedication).subscribe({
			next: (med1) => {
				this.txService.createTransactionHistory('Medications', this.selectedMedication.id);

				const uploads = this.localImages.slice(0, 2).map(img => {
					const imageData = {
						medicationId: this.selectedMedication.id,
						imageType: img.imageType
					} as MedicationImage;

					return img.file
						? this.medicationService.createMedicationImage(imageData, img.file)
						: this.medicationService.createMedicationImageFromBase64Encoded(
							imageData, img.base64, `${this.selectedMedication.origNdcNumber}_${img.imageType}.jpg`
						);
				});

				if (uploads.length === 0) {
					this.submitClicked.emit(this.selectedMedication);
				} else {
					forkJoin(uploads).subscribe({
						next: () => this.submitClicked.emit(this.selectedMedication),
						error: err => Settings.getInstance().handleError(err)
					});
				}
			},
			error: err => Settings.getInstance().handleError(err)
		});
	}

	public addNewMedication() {
		let newRecord = new Medication();
		newRecord.description = this.valDesc;
		newRecord.rawNdcNumber = this.valRawNDCNumber;
		newRecord.origNdcNumber = this.valOMNDCNumber;
		newRecord.ndcFormat = this.valNdcFormat;
		newRecord.packageSize = this.valPkgSize;
		if (this.selectedManuBy) {
			newRecord.manufacturedById = this.selectedManuBy.id;
		}
		if (this.selectedManuFor) {
			newRecord.manufacturedForId = this.selectedManuFor.id;
		}

		newRecord.activeStatus = "Active";
		newRecord.awp = this.valAWP;
		newRecord.lastCost = this.valPrice;
		newRecord.medicationFamilyId = this.selectedMedicationFamily.id;
		newRecord.storageInstructions = this.valStorageInstructions;

		this.medicationService.createMedication(newRecord).subscribe({
			next: (med) => {
				this.selectedMedication = med;
				this.txService.createTransactionHistory('Medications', med.id);

				const uploads = this.localImages.slice(0, 2).map(img => {
					const imageData = {
						medicationId: med.id,
						imageType: img.imageType
					} as MedicationImage;

					return img.file
						? this.medicationService.createMedicationImage(imageData, img.file)
						: this.medicationService.createMedicationImageFromBase64Encoded(imageData, img.base64, `${med.ndc}_${img.imageType}.jpg`);
				});

				if (uploads.length === 0) {
					this.submitClicked.emit(this.selectedMedication);
				} else {
					forkJoin(uploads).subscribe({
						next: () => this.submitClicked.emit(this.selectedMedication),
						error: err => Settings.getInstance().handleError(err)
					});
				}
			},
			error: err => Settings.getInstance().handleError(err)
		});

	}


	public cancelSubmitRecord() {
		this.clear();
		this.cancelClicked.emit();
	}

	doImageSelectedTabChange(event: any) {
		this.imageTabIndex = event.index;
	}

	private addImage(event: any, imageType: 'Container' | 'Dose') {
		console.log('addImage called with:', { event, imageType });

		let newImage: any = null;

		if (typeof event === 'string') {
			console.log('Event has base64 data');
			newImage = { base64: event, imageType };
		} else if (event) {
			console.log('Event has file input');
			newImage = { file: event, imageType };
		} else {
			console.warn('No valid image data found in event:', event);
		}

		if (newImage) {
			console.log('New image to add or replace:', newImage);
			const idx = this.localImages.findIndex(img => img.imageType === imageType);
			if (idx !== -1) {
				console.log(`Replacing existing image at index ${idx}`);
				this.localImages[idx] = newImage;
			} else {
				console.log('Adding new image to localImages');
				this.localImages.push(newImage);
			}
		}

		console.log('Current state of localImages:', this.localImages);
	}


	onPasteSelectedHandler(event: any) { this.addImage(event, 'Container'); }
	onFileSelectedHandler(event: any) { this.addImage(event, 'Container'); }
	onDosePasteSelectedHandler(event: any) { this.addImage(event, 'Dose'); }
	onDoseFileSelectedHandler(event: any) { this.addImage(event, 'Dose'); }

	public showQuickAddManuFor(): void {
		this.displayManuForDlg = true;
		this.quickAddManuFor.onShowHandler(this.valOMNDCNumber);
	}
	public showQuickAddManuBy(): void {
		this.displayManuByDlg = true;
		this.quickAddManuBy.onShowHandler();
	}
	setManuByRecord(data) {
		this.displayManuByDlg = false;
		this.manufactureByList.push(data);
		this.selectedManuBy = data;
	}
	setManuForRecord(data) {
		this.displayManuForDlg = false;
		this.manufactureForList.push(data);
		this.selectedManuFor = data;
	}
	onFileErrorHandler(err) {
		this.strErr = err;
	}

	openMedlineLink(ndc: string): void {
		if (ndc) {
			const url = `https://www.dailymed.nlm.nih.gov/dailymed/search.cfm?labeltype=all&query=${encodeURIComponent(ndc)}`;
			window.open(url, '_blank', 'noopener');
		}
	}


	public manuBySelected(id: number) {
		this.selectedManuBy = this.manufactureByList.find(item => item.id === id);
	}
	public manuForSelected(id: number) {
		this.selectedManuFor = this.manufactureForList.find(item => item.id === id);
	}

}
